import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(theme => {
  return {
    root: {
      width: '100%',
      maxWidth: '700px',
      margin: 'auto',
    },
    paper: {
      margin: theme.spacing(4),
      padding: theme.spacing(4),
    },
    content: {
      
    }
  }
})

const Page = ({
  children,
}) => {
  const classes = useStyles()
  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <div className={ classes.content }>
          { children }
        </div>
      </Paper>
    </div>
  )
}

export default Page